import { useNavigate } from "react-router-dom";
import Page from "src/layouts/Page";
import ContentTable, {
	ContentTableItem
} from "src/components/ContentTable/ContentTable";
import useFavouriteFeeds from "../../hooks/useFavouriteFeeds";
import useMoveFavouriteFeed from "../../hooks/useMoveFavouriteFeed";
import { mapFavouritesToContentTableItems } from "../../utils/mapFavouritesToContentTableItems";

const FavouriteFeeds = () => {
	const navigate = useNavigate();

	const { data: favourites = [] } = useFavouriteFeeds();
	const { mutate: moveFavouriteFeed, isLoading: isMoving } =
		useMoveFavouriteFeed();

	const items = mapFavouritesToContentTableItems(favourites);

	const handleMove = (item: ContentTableItem, direction: -1 | 1) => {
		if (isMoving) return;
		moveFavouriteFeed({ uuid: String(item.id), offset: direction });
	};

	return (
		<Page>
			<ContentTable
				items={items}
				showCreatedBy={false}
				showLastUpdated={false}
				showStatus={false}
				// Favourite feeds are hashtags — row click navigates to the Hashtag edit page
				onRowClick={(item) => navigate(`/social-feed/hashtags/${item.id}`)}
				onMoveUp={(item) => handleMove(item, -1)}
				onMoveDown={(item) => handleMove(item, 1)}
			/>
		</Page>
	);
};

export default FavouriteFeeds;
